const contactBoilerplate = {

    EmployeeEmergencyContactId: null,
    EmployeeId: null,
    EmergencyContactName: null,
    EmergencyContactPhone: null,
    CreatedDate: null,
    CreatedBy: null,
    ModifyDate: null,
    ModifiedBy: null,
    DeletedDate: null,
    DeletedBy: null,
    DisabledDate: null,
    DisabledBy: null
}

export default contactBoilerplate